var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":"app"}},[_c('Menu'),_c('div',{staticClass:"col",attrs:{"id":"bodyApp"}},[_c('Navtop'),_c('div',{staticClass:"m-4"},[_c('router-view')],1)],1),_c('ModalUpgrade',{attrs:{"id":"ModalUpgradePush","type":"push"}}),_c('ModalUpgrade',{attrs:{"id":"ModalUpgradeWpp","type":"whatsapp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }